import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';

class BlockImageData {
  url?: BlockComponentImage;
  backgroundImage?: BlockComponentImage;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockImageData {
  export function make(url?: string, backgroundImage?: string): BlockImageData {
    return {
      url: BlockComponentImage.make(url),
      backgroundImage: BlockComponentImage.make(backgroundImage),
    };
  }

  export function getDefault(url = ''): BlockImageData {
    return make(url);
  }
}

export default BlockImageData;
